import React from "react"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import TableActionBar from "../../../components/layout/TableActionBar"
import { Paper, Table, TableBody, TableRow, TableRowColumn, CircularProgress, Toggle } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { ISchedulePatternTemplate, IScheduleDailyTimelineData, IScheduleShift } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import * as AccountActions from "../../../actions/AccountActions"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import AddPatternTemplateDialog from "./AddPatternTemplateDialog"
import PatternTemplateTimelineTable from "./PatternTemplateTimelineTable"
import AddShiftTemplateInPatternTemplate from "./AddShiftTemplateInPatternTemplate"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import _ from "lodash"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
interface IState {
  showAllChildHierarchyData: boolean
  patternTemplates: ISchedulePatternTemplate[]
  selectedPatternTemplates: ISchedulePatternTemplate[]
  searchText: string
  loading: boolean
  openAddPatternTemplateDialog: boolean
  editPatternTemplate: ISchedulePatternTemplate
  patternTemplateForAddShiftTemplate: ISchedulePatternTemplate
}
export default class PatternTemplates extends React.Component<any, IState> {
  constructor(props) {
    super(props)
    this.state = {
      showAllChildHierarchyData: true,
      patternTemplates: [],
      selectedPatternTemplates: [],
      searchText: "",
      loading: false,
      openAddPatternTemplateDialog: false,
      editPatternTemplate: null,
      patternTemplateForAddShiftTemplate: null,
    }
    autobind(this)
  }

  componentDidMount() {
    AccountStore.on("account_change", this.getPatternTemplates)
    HierarchySettingsStore.on("change", this.getPatternTemplates)
    this.getPatternTemplates()
  }

  componentWillUnmount() {
    AccountStore.removeListener("account_change", this.getPatternTemplates)
    HierarchySettingsStore.removeListener("change", this.getPatternTemplates)
  }

  getPatternTemplates() {
    if (!AccountStore.getCurrentAccount()) return
    const hierarchyIdsForShowAllChildHierarchyData = hierarchyHelper.getHierarchyIdsForShowAllChildHierarchyData(
      this.state.showAllChildHierarchyData,
      HierarchySettingsStore.getGlobalLevelItemFilterId()
    )
    const patternTemplates = AccountStore.getCurrentAccount().ScheduleData.PatternTemplates
      .filter((item) =>
        !item.Deleted &&
        (hierarchyIdsForShowAllChildHierarchyData.find((id) => id === item.HierarchyId) === undefined ? false : true) &&
        (this.state.searchText ?
          item.Name.toLowerCase().includes(this.state.searchText.toLowerCase()) || item.Description.toLowerCase().includes(this.state.searchText.toLowerCase()) :
          true)
      )
      .sort((a, b) => {
        if (a.Name < b.Name) return -1
        if (a.Name > b.Name) return 1
        return 0
      })

    this.setState({
      loading: false,
      patternTemplates,
      selectedPatternTemplates: [],
    })
  }

  handleAdd(patternTemplate) {
    AppStateStore.setProgressSnackbarContent("loading")
    this.setState({ openAddPatternTemplateDialog: false, editPatternTemplate: null }, () =>
      AccountActions.addPatternTemplate(AccountStore.getCurrentAccount().Id, patternTemplate, () =>
        AppStateStore.setProgressSnackbarContent(strings.Pattern_template_added_successfully)
      )
    )
  }

  handleUpdate(patternTemplate, progressContent) {
    AppStateStore.setProgressSnackbarContent("loading")
    this.setState({ openAddPatternTemplateDialog: false, editPatternTemplate: null, patternTemplateForAddShiftTemplate: null }, () =>
      AccountActions.updatePatternTemplate(AccountStore.getCurrentAccount().Id, patternTemplate, () =>
        AppStateStore.setProgressSnackbarContent(progressContent)
      )
    )
  }

  handleDelete(patternTemplates: ISchedulePatternTemplate[]) {
    AppStateStore.setProgressSnackbarContent("loading")
    AccountActions.deletePatternTemplates(AccountStore.getCurrentAccount().Id, patternTemplates.map(item => item.Id), () => {
      AppStateStore.setProgressSnackbarContent(strings.Pattern_template_deleted_successfully)
      this.setState({ loading: true }, () => this.setState({ loading: false }))
    })
  }

  checkValidateNewTimeline(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): boolean {
    const timelineItemData = _.cloneDeep(this.state.patternTemplates)[rowNumber]
    const updatedShiftTemplate = timelineItemData.ShiftTemplates[orderNumber]
    updatedShiftTemplate.StartTime = timelineItem.StartTime
    updatedShiftTemplate.EndTime = timelineItem.EndTime
    updatedShiftTemplate.Breaks = timelineItem.Breaks
    const isOverlapValidate = scheduleHelper.checkOverlapShifts(
      updatedShiftTemplate,
      timelineItemData.ShiftTemplates.filter((item) => item.Id !== updatedShiftTemplate.Id))
    let isBreakValidate = true
    if (isOverlapValidate) {
      isBreakValidate = scheduleHelper.checkValidateShiftBreakTimes(updatedShiftTemplate)
      !isBreakValidate && AppStateStore.setProgressSnackbarContent(strings.Break_Time_Window_should_be_fall_in_shift_time)
    }
    else {
      AppStateStore.setProgressSnackbarContent(strings.Cannot_overlap_shift_template_times)
    }
    return isOverlapValidate && isBreakValidate
  }

  handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number) {
    const patternTemplate = this.state.patternTemplates[rowNumber]
    patternTemplate.ShiftTemplates[orderNumber].StartTime = timelineItem.StartTime
    patternTemplate.ShiftTemplates[orderNumber].EndTime = timelineItem.EndTime
    AccountActions.updatePatternTemplate(AccountStore.getCurrentAccount().Id, patternTemplate, () => {
      AppStateStore.setProgressSnackbarContent(strings.Shift_template_time_updated_successfully)
    })
  }

  handleDeleteTimelineItem(rowNumber: number, orderNumber: number) {
    const patternTemplate = this.state.patternTemplates[rowNumber]
    patternTemplate.ShiftTemplates.splice(orderNumber, 1)
    AccountActions.updatePatternTemplate(AccountStore.getCurrentAccount().Id, patternTemplate, () => {
      AppStateStore.setProgressSnackbarContent(strings.Shift_template_time_removed_successfully)
    })
  }

  handleUpdateTimelineItem(item: IScheduleShift, rowNumber: number, orderNumber: number) {
    const patternTemplate = this.state.patternTemplates[rowNumber]
    patternTemplate.ShiftTemplates[orderNumber] = item
    AccountActions.updatePatternTemplate(AccountStore.getCurrentAccount().Id, patternTemplate, () => {
      AppStateStore.setProgressSnackbarContent(strings.Shift_template_updated_successfully)
    })
  }

  render() {
    return (
      <div className="page-container">
        <div className="page-container-parent">
          {permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.AddAccountSchedule) &&
            <FloatingActionButton className="fixed-add" style={{ top: 83, right: 40, zIndex: 998 }} secondary={true} onTouchTap={() => this.setState({ openAddPatternTemplateDialog: true })}>
              <ContentAdd />
            </FloatingActionButton>
          }
          <Paper zDepth={1} className="page-paper">
            <div style={{ width: "100%", marginTop: 20, display: "flex", justifyContent: "flex-end" }}>
              <Toggle
                label={strings.Show_All_Child_Hierarchy_Data}
                style={{ width: 275, paddingRight: 35 }}
                labelStyle={{ fontSize: 15, fontWeight: 500 }}
                toggled={this.state.showAllChildHierarchyData}
                onToggle={(e, value) => this.setState({ showAllChildHierarchyData: value }, () => this.getPatternTemplates())}
              />
            </div>
            <TableActionBar
              rowSelectionCount={this.state.selectedPatternTemplates.length}
              singleSelectedMessage={strings.Pattern_Template_Selected}
              multipleSelectedMessage={strings.x_Pattern_Template_Selected}
              title={strings.Pattern_Templates}
              onSearch={(searchText) => this.setState({ searchText }, () => this.getPatternTemplates())}
              searchText={this.state.searchText}
              onDeleteClick={() =>
                AppStateStore.setConfirmDialogContent({
                  content: strings.Are_you_sure_you_want_to_delete_the_selected_pattern_template,
                  confirm: () => this.handleDelete(this.state.selectedPatternTemplates)
                })
              }
              readonly={false}
            />
            <div style={{ padding: 20 }}>
              {this.state.loading ?
                <div className="spinner"><CircularProgress /></div> :
                <div>
                  {!this.state.patternTemplates.length ?
                    <Table>
                      <TableBody displayRowCheckbox={false}>
                        <TableRow>
                          <TableRowColumn>
                            <h2 style={{ textAlign: "center", marginTop: 25 }}>
                              {strings.No_pattern_template_found}
                            </h2>
                          </TableRowColumn>
                        </TableRow>
                      </TableBody>
                    </Table> :
                    <PatternTemplateTimelineTable
                      patternTemplates={this.state.patternTemplates}
                      handleUpdate={(editPatternTemplate) => permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule) && this.setState({ openAddPatternTemplateDialog: true, editPatternTemplate })}
                      handleSelect={(selectedPatternTemplates) => this.setState({ selectedPatternTemplates })}
                      handleAddShiftTemplate={(patternTemplateForAddShiftTemplate) => this.setState({ patternTemplateForAddShiftTemplate })}
                      handleUpdateTimelineData={this.handleUpdateTimelineData}
                      checkValidateNewTimeline={this.checkValidateNewTimeline}
                      handleDeleteTimelineItem={this.handleDeleteTimelineItem}
                      handleUpdateTimelineItem={this.handleUpdateTimelineItem}
                    />
                  }
                </div>
              }
            </div>
          </Paper>
        </div>
        {this.state.openAddPatternTemplateDialog &&
          <AddPatternTemplateDialog
            editPatternTemplate={this.state.editPatternTemplate}
            handleClose={() => this.setState({ openAddPatternTemplateDialog: false, editPatternTemplate: null })}
            handleAdd={this.handleAdd}
            handleUpdate={(patternTemplate) => this.handleUpdate(patternTemplate, strings.Pattern_template_updated_successfully)}
          />
        }
        {this.state.patternTemplateForAddShiftTemplate &&
          <AddShiftTemplateInPatternTemplate
            patternTemplate={this.state.patternTemplateForAddShiftTemplate}
            handleUpdate={(patternTemplate) => this.handleUpdate(patternTemplate, strings.Shift_template_added_successfully)}
            handleClose={() => this.setState({ patternTemplateForAddShiftTemplate: null })}
          />
        }
      </div>
    )
  }
}